var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHomeBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.55 30.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.55,16.1A1.83,1.83,0,0,1,31.85,18H28.59V28.33a1.82,1.82,0,0,1-1.7,1.93H21.3a1.83,1.83,0,0,1-1.7-1.93V22.87a3,3,0,0,0-2.83-3.22,3.05,3.05,0,0,0-2.84,3.22v5.45a1.83,1.83,0,0,1-1.7,1.94H6.64a1.83,1.83,0,0,1-1.7-1.94V18H1.7A1.72,1.72,0,0,1,.1,16.76a2.13,2.13,0,0,1,.52-2.15L15.68.44a1.55,1.55,0,0,1,2.17,0l14.93,14A2,2,0,0,1,33.55,16.1Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeBlack);
export default __webpack_public_path__ + "static/media/icon_home-black.21eb9bb5f1ea024c32897fc80888e848.svg";
export { ForwardRef as ReactComponent };